import replace from 'lodash/replace'

import { stripEmoji } from '@Components/Personalization/Util/helpers'

export const sanitizeText = (text: string, length: number, deboss: boolean = false) => {
  let newText = stripEmoji(`${text}`)
  if (deboss) {
    newText = replace(newText, /[^a-zA-Z0-9.\sæøåöä&üÆØÅÖÄÜáÁéÉóÓúÚàÀ]/g, '')
  }
  return newText.slice(0, length)
}

export const checkDebossError = (text: string) => {
  const newText = stripEmoji(`${text}`)
  return !!newText.match(/[^a-zA-Z0-9.\sæøåöä&üÆØÅÖÄÜáÁéÉóÓúÚàÀ]/g)
}
